import React from "react";
import { observer } from "mobx-react";

import SideNav from "../SideNav";
import PmPatientList from "../PmPatientList";
import EventsSidebar from "../EventsSidebar";
import SideBarStore from "./SideBarStore";

export const SidebarContext = React.createContext();

export default observer(function SideBar({ historyType, parent }) {
  const store = React.useMemo(() => new SideBarStore(), []);

  function startDrag(e) {
    e.stopPropagation();
    e.preventDefault();
    const startX = e.clientX;
    const { width } = store;
    function mousemove(e) {
      store.width = width + e.clientX - startX;
    }
    function endDrag() {
      removeEventListener("mousemove", mousemove);
    }
    addEventListener("mousemove", mousemove);
    addEventListener("mouseup", endDrag, { once: true });
  }

  return (
    <SidebarContext.Provider value={store}>
      <SideNav />
      {historyType !== "event" && store.selection === "patients" ? (
        <PmPatientList parent={parent} />
      ) : (
        <EventsSidebar parent={parent} />
      )}
      <div className="divider" onMouseDown={startDrag} />
    </SidebarContext.Provider>
  );
});
